import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import FeatureSectionUsecases from 'src/components/features/feature-section-usecases';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

// data
import {
  metaData,
  productHeaderData,
  featuresData,
  interactiveData,
  featureSectionData,
  footerExtensionData,
} from 'src/store/en-eu/products/auth';

import { ProductPageTemplate } from 'src/templates';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const EUProductAuth = ({ locale = Locales.EN_EU }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <InteractiveData {...interactiveData} />
      <FeatureSectionUsecases {...featureSectionData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default EUProductAuth;
